const NO_PRINT_GUIDELINES_PDF =
  'https://cms.cloudinary.vpsvc.com/image/upload/v1689687384/NPIB-3875-Booklet-guidelines-001_NO.pdf';

const SE_PRINT_GUIDELINES_PDF =
  'https://cms.cloudinary.vpsvc.com/image/upload/v1689687384/NPIB-3875-Booklet-guidelines-001_SE.pdf';

const DE_PRINT_GUIDELINES_PDF =
  'https://cms.cloudinary.vpsvc.com/image/upload/v1689687356/NPIB-3875-Booklet-guidelines-001_DE.pdf';

const GB_PRINT_GUIDELINES_PDF =
  'https://cms.cloudinary.vpsvc.com/image/upload/v1689687384/NPIB-3875-Booklet-guidelines-001_GB.pdf';

const NL_PRINT_GUIDELINES_PDF =
  'https://cms.cloudinary.vpsvc.com/image/upload/v1689687336/NPIB-3875-Booklet-guidelines-001_NL.ai';

const CAFR_PRINT_GUIDELINES_PDF =
  'https://cms.cloudinary.vpsvc.com/image/upload/v1689687349/NPIB-3875-Booklet-guidelines-001_CAFR.pdf';

const USES_PRINT_GUIDELINES_PDF =
  'https://cms.cloudinary.vpsvc.com/image/upload/v1689687384/NPIB-3875-Booklet-guidelines-001_USES.pdf';

const FI_PRINT_GUIDELINES_PDF =
  'https://cms.cloudinary.vpsvc.com/image/upload/v1689687354/NPIB-3875-Booklet-guidelines-001_FI.pdf';

const FR_PRINT_GUIDELINES_PDF =
  'https://cms.cloudinary.vpsvc.com/image/upload/v1689687356/NPIB-3875-Booklet-guidelines-001_FR.pdf';

const DK_PRINT_GUIDELINES_PDF =
  'https://cms.cloudinary.vpsvc.com/image/upload/v1689687353/NPIB-3875-Booklet-guidelines-001_DK.pdf';

const PT_PRINT_GUIDELINES_PDF =
  'https://cms.cloudinary.vpsvc.com/image/upload/v1689687392/NPIB-3875-Booklet-guidelines-001_PT.pdf';

const IT_PRINT_GUIDELINES_PDF =
  'https://cms.cloudinary.vpsvc.com/image/upload/v1689687384/NPIB-3875-Booklet-guidelines-001_IT.pdf';

const ES_PRINT_GUIDELINES_PDF =
  'https://cms.cloudinary.vpsvc.com/image/upload/v1689687355/NPIB-3875-Booklet-guidelines-001_ES.pdf';

export const LOCALIZED_URLS: { [key: string]: string | null } = {
  'da-dk': DK_PRINT_GUIDELINES_PDF,
  'de-at': DE_PRINT_GUIDELINES_PDF,
  'de-ch': DE_PRINT_GUIDELINES_PDF,
  'de-de': DE_PRINT_GUIDELINES_PDF,
  'en-au': null,
  'en-ca': null,
  'en-gb': GB_PRINT_GUIDELINES_PDF,
  'en-ie': GB_PRINT_GUIDELINES_PDF,
  'en-in': null,
  'en-nz': null,
  'en-us': null,
  'es-es': ES_PRINT_GUIDELINES_PDF,
  'es-us': USES_PRINT_GUIDELINES_PDF,
  'fi-fi': FI_PRINT_GUIDELINES_PDF,
  'fr-be': FR_PRINT_GUIDELINES_PDF,
  'fr-ca': CAFR_PRINT_GUIDELINES_PDF,
  'fr-ch': FR_PRINT_GUIDELINES_PDF,
  'fr-fr': FR_PRINT_GUIDELINES_PDF,
  'it-ch': IT_PRINT_GUIDELINES_PDF,
  'it-it': IT_PRINT_GUIDELINES_PDF,
  'nb-no': NO_PRINT_GUIDELINES_PDF,
  'nl-be': NL_PRINT_GUIDELINES_PDF,
  'nl-nl': NL_PRINT_GUIDELINES_PDF,
  'pt-pt': PT_PRINT_GUIDELINES_PDF,
  'sv-se': SE_PRINT_GUIDELINES_PDF,
};

export const DEFAULT_LOCALE_ROUTE = '/upload-and-print';
export const LOCALIZED_ROUTES: { [key: string]: string } = {
  'da-dk': '/upload-og-tryk',
  'de-at': '/hochladen-und-drucken',
  'de-ch': '/hochladen-und-drucken',
  'de-de': '/hochladen-und-drucken',
  'en-au': DEFAULT_LOCALE_ROUTE,
  'en-ca': DEFAULT_LOCALE_ROUTE,
  'en-gb': DEFAULT_LOCALE_ROUTE,
  'en-ie': DEFAULT_LOCALE_ROUTE,
  'en-in': DEFAULT_LOCALE_ROUTE,
  'en-nz': DEFAULT_LOCALE_ROUTE,
  'en-sg': DEFAULT_LOCALE_ROUTE,
  'en-us': DEFAULT_LOCALE_ROUTE,
  'es-es': '/subir-e-imprimir',
  'es-us': '/es/subir-e-imprimir',
  'fi-fi': '/lataa-ja-tulosta',
  'fr-be': '/fr/telecharger-et-imprimer',
  'fr-ca': '/fr/televerser-et-imprimer',
  'fr-ch': '/fr/telecharger-et-imprimer',
  'fr-fr': '/telecharger-et-imprimer',
  'ja-jp': DEFAULT_LOCALE_ROUTE,
  'it-ch': '/it/carica-e-stampa',
  'it-it': '/carica-e-stampa',
  'nb-no': '/last-opp-og-send-i-trykken',
  'nl-be': '/uploaden-en-printen',
  'nl-nl': '/uploaden-en-printen',
  'pt-pt': '/carregar-e-imprimir',
  'sv-se': '/ladda-upp-och-tryck',
};
